import React from 'react';

import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import ImageIcon from '@mui/icons-material/Image';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import ViewCompactIcon from '@mui/icons-material/ViewCompact';
import BackupTableIcon from '@mui/icons-material/BackupTable';
import ListIcon from '@mui/icons-material/List';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import HttpIcon from '@mui/icons-material/Http';
import ExtensionIcon from '@mui/icons-material/Extension';
import TabletMacIcon from '@mui/icons-material/TabletMac';
import WebIcon from '@mui/icons-material/Web';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import CategoryIcon from '@mui/icons-material/Category';
import LocalMoviesIcon from '@mui/icons-material/LocalMovies';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import ChatIcon from '@mui/icons-material/Chat';
import DateRangeIcon from '@mui/icons-material/DateRange';
import CropFreeIcon from '@mui/icons-material/CropFree';
import BusinessIcon from '@mui/icons-material/Business';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import PickerIcon from '@mui/icons-material/PanoramaWideAngle';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';
import AtmIcon from '@mui/icons-material/Atm';
import BarChartIcon from '@mui/icons-material/BarChart';
import SwipeDownIcon from '@mui/icons-material/SwipeDown';
import PhotoSizeSelectSmallIcon from '@mui/icons-material/PhotoSizeSelectSmall';
import LeakAddIcon from '@mui/icons-material/LeakAdd';
import MapIcon from '@mui/icons-material/Map';
import EarbudsIcon from '@mui/icons-material/Earbuds';

export const ruleList = [
	{
		type:'targetComponent',
		name:'Root',
		description:'필수 - 변환하고자 할 스캐치의 노드를 선택해주세요.',
		icon:()=>(<DeviceHubIcon/>),
		unique: true,
		elements:['node']
	},
	{
		type:'mappingImage',
		name:'Image',
		description:'스캐치의 노드를 PUI블록의 이미지 데이터와 매핑합니다',
		icon:()=>(<ImageIcon/>),
		unique: false,
		elements:['node','data']
	},
	{
		type:'mappingText',
		name:'Text',
		description:'스캐치의 노드를 PUI블록의 텍스트와 매핑합니다',
		icon:()=>(<TextFieldsIcon/>),
		unique: false,
		elements:['node','data']
	},
	{
		type:'mappingClick',
		name:'Click',
		description:'스캐치의 노드에 클릭기능을 추가합니다',
		icon:()=>(<ExitToAppIcon/>),
		unique: false,
		elements:['node','data']
	},
	{
		type:'layout',
		name:'Layout',
		description:'가변좌우상하, 센터, 넥스트 정렬',
		icon:()=>(<BackupTableIcon/>),
		unique: false,
		elements:['node','data']
	},
	{
		type:'repeat',
		name:'List',
		description:'데이터의 길이에 따라 노드를 반복시킨다. 반복노드를 선택하면 그 그룹의 다른 노드는 사라진다.',
		icon:()=>(<ListIcon/>),
		unique: false,
		elements:['node','data']
	},
	{
		type:'hidden',
		name:'Hidden',
		description:'Hidden node by if condition',
		icon:()=>(<VisibilityIcon/>),
		unique: false,
		elements:['node','data']
	},
	{
		type:'extension',
		name:'Ext',
		description:'This rule convert sketch area to pre-developed ui module.',
		icon:()=>(<ExtensionIcon/>),
		help:'https://muyoungko.blogspot.com/2018/08/sketch-to-app-extension.html',
		bg : 'btn-outline-danger',
		unique: false,
		elements:['node','data']
	},

	{
		type:'icon',
		name:'Icon',
		description:'Show Icon by json data matched with sketch node name',
		icon:()=>(<CategoryIcon/>),
		unique: false,
		elements:['node','data'],
		help:'https://muyoungko.blogspot.com/2018/08/sketch-to-app-extension.html',
	},
	{
		type:'mappingColor',
		name:'Color',
		description:'Change Color by data',
		icon:()=>(<ColorLensIcon/>),
		unique: false,
		elements:['node','data']
	},

	// {
	// 	type:'mappingTablet',
	// 	name:'Tablet Sketch Root',
	// 	description:'This rule is about how to stretch to tablet',
	// 	icon:()=>(<TabletMacIcon/>),
    //   	bg : 'btn-outline-danger',
	// 	unique: false,
	// 	elements:['node','data']
	// },
	{
		type:'web',
		name:'WebView',
		description:'Webview',
		icon:()=>(<WebIcon/>),
		unique: false,
		elements:['node','string']
	},

	{
		type:'timer',
		name:'Timer',
		description:'Timer Count Down',
		icon:()=>(<AccessAlarmIcon/>),
		unique: false,
		elements:['node','string']
	},

	{
		type:'fix',
		name:'Fixed',
		description:'Fixed View when Scroll',
		icon:()=>(<PhotoSizeSelectSmallIcon/>),
		unique: false,
		elements:['node','string']
	},
	
	{
		type:'strip',
		name:'VPStrip',
		description:'ViewPagerStrip',
		icon:()=>(<ViewCarouselIcon/>),
		unique: false,
		elements:['node','string']
	},

	{
		type:'lottie',
		name:'Lottie',
		description:'Lottie',
		icon:()=>(<LocalMoviesIcon/>),
		unique: false,
		elements:['node','string']
	},
	{
		type:'video',
		name:'Video',
		description:'Video',
		icon:()=>(<PlayCircleFilledIcon/>),
		unique: true,
		elements:['node','json','json', 'boolean']
	},
	{
		type:'qrcode',
		name:'Qr',
		description:'QR Code',
		icon:()=>(<CropFreeIcon/>),
		unique: true,
		elements:['node','json','json', 'boolean']
	},
	{
		type:'chat',
		name:'Chat',
		description:'Chat',
		icon:()=>(<ChatIcon color='secondary'/>),
		unique: true,
		elements:['node','json','json', 'boolean']
	},
	{
		type:'calendar',
		name:'Calendar',
		description:'Calendar',
		icon:()=>(<DateRangeIcon color='secondary'/>),
		unique: true,
		elements:['node','json','json', 'boolean']
	},
	
	{
		type:'address-popup',
		name:'Address',
		description:'Address Input',
		icon:()=>(<BusinessIcon color='secondary'/>),
		unique: true,
		elements:['node','json','json', 'boolean']
	},

	{
		type:'kr.co.july.address-select',
		name:'Address',
		description:'Address Select',
		icon:()=>(<LocationCityIcon color='secondary'/>),
		unique: true,
		elements:['node','json','json', 'boolean']
	},
	{
		type:'star-rating',
		name:'Star',
		description:'Star Rating',
		icon:()=>(<StarHalfIcon color='secondary'/>),
		unique: true,
		elements:['node']
	},

	{
		type:'kr.co.july.picker',
		name:'Picker',
		description:'Picker Select List',
		icon:()=>(<PickerIcon color='secondary'/>),
		unique: true,
		elements:['node']
	},

	{
		type:'kr.co.july.imagemap',
		name:'Image Map',
		description:'Image Map',
		icon:()=>(<ZoomOutMapIcon color='secondary'/>),
	},
	{
		type:'kr.co.july.googleads',
		name:'Google Ads',
		description:'Google Ads',
		icon:()=>(<AtmIcon color='secondary'/>),
	},

	{
		type:'kr.co.july.chart',
		name:'Chart',
		description:'Chart',
		icon:()=>(<BarChartIcon color='secondary'/>),
	},
	{
		type:'kr.co.july.blockdrawer',
		name:'Block Drawer',
		description:'Block Drawer',
		icon:()=>(<SwipeDownIcon color='secondary'/>),
	},
	{
		type:'kr.co.july.map',
		name:'Google Map',
		description:'Google Map View',
		icon:()=>(<MapIcon color='secondary'/>),
	},
	{
		type:'kr.co.july.paint',
		name:'Paint View',
		description:'Paint View',
		icon:()=>(<EarbudsIcon color='secondary'/>),
	},
];
